import { render } from "./AdminIcon.vue?vue&type=template&id=53f8bed2&scoped=true"
import script from "./AdminIcon.vue?vue&type=script&lang=js"
export * from "./AdminIcon.vue?vue&type=script&lang=js"

import "./AdminIcon.vue?vue&type=style&index=0&id=53f8bed2&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53f8bed2"]])

export default __exports__